var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSectorBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 22,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16.115,
  height: 17.28,
  x: 0.599,
  y: 0.845,
  stroke: "#4264fd",
  strokeWidth: 1.5,
  rx: 1.25,
  transform: "matrix(.98936 .14551 -.19023 .98174 3.74 .428)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#4264fd",
  strokeWidth: 1.5,
  d: "m1.924 11.218 16.752 1.281M9.142 2.509l-1.567 8.839M13.951 11.636l-2.094 8.715"
})));
export default SvgIconSectorBlue;